import styled from "styled-components"
import { Flex } from "@quorumus/plum"

export const CollapseWrapper = styled.div<{ isOpen: boolean }>`
    background-color: var(--plum-gray-1);
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    button {
        padding: 0;
        color: var(--plum-black);
        font-size: 16px;
        font-weight: 600;
        margin-bottom: ${(props) => (props.isOpen ? "8px" : "0")};
    }
`

export const StyledDateRow = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid var(--plum-gray-4);
    padding-bottom: 8px;
    margin-bottom: 8px;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    span {
        font-weight: 400;
        font-size: 14px;
        color: var(--plum-black);
        line-height: normal;
    }

    p {
        font-weight: 400;
        font-size: 14px;
        color: var(--plum-black);
        line-height: normal;
        margin: 0;
    }

    i {
        margin-left: 4px;
    }

    a {
        color: var(--plum-blue-7);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
    }
`
